/* global getComputedStyle */
const DeviceMenu = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const hamBurger = document.querySelector('.hamburger');
        const overlay = document.querySelectorAll('.mbnav__backdrop, .mbnav__close');
        const body = document.body;
        const mbnav = document.querySelector('.mbnav');
        const transparentHeader = document.querySelector('.main-header.transparent-header');

        if ( !hamBurger || !mbnav ) {
            return;
        }

        function menuClose() {
            hamBurger.classList.remove('is-clicked');
            body.classList.remove('scroll-fixed');
            mbnav.classList.remove('is-open');
            mbnav.querySelectorAll('.menu-wrap li').forEach(li => {
                li.classList.remove('is-open', 'open');
                delete li.dataset.redirectOnNextClick;
            });
            document.querySelector('.mbnav__inner > .menu-wrap').style.setProperty('--leftSlide', '0');
            transparentHeader && transparentHeader.classList.remove('mb-stuck');
        }

        function getLinkHref(link) {
            return link ? link.dataset.mbnavHref || link.getAttribute('href') : '';
        }

        function updateMenuSlide(offset) {
            const menuLeftMove = document.querySelector('.mbnav__inner > .menu-wrap');
            const current = parseInt(getComputedStyle(menuLeftMove).getPropertyValue('--leftSlide')) || 0;
            menuLeftMove.style.setProperty('--leftSlide', (current + offset) + '%');
        }

        // Overlay click
        overlay.forEach(el => {
            el.addEventListener('click', menuClose);
        });

        // Hamburger click
        hamBurger.addEventListener('click', () => {
            if (hamBurger.classList.contains('is-clicked')) {
                menuClose();
            } else {
                hamBurger.classList.add('is-clicked');
                mbnav.classList.add('is-open');
                body.classList.add('scroll-fixed');
                transparentHeader && transparentHeader.classList.add('mb-stuck');
            }
        });

        // Mark has-sub
        const mbnavState = document.querySelector('.mbnav__state');
        const clickable = mbnavState ? mbnavState.getAttribute('data-clickable') === 'true' : false;
        const menuItems = document.querySelectorAll('.mbnav ul.menu > li');

        menuItems.forEach(li => {
            if (li.querySelector('ul')) {
                li.classList.add('has-sub');
                const ul = li.querySelector('ul');
                ul.classList.add('sub-menu');
                const link = li.querySelector('a');
                if (link) {
                    link.dataset.mbnavHref = link.getAttribute('href') || '';

                    const caret = document.createElement('em');
                    caret.className = 'mbnav__caret';
                    link.insertAdjacentElement('afterend', caret);
                }

                // Insert Back and Parent Title
                if (ul) {
                    const parentTitle = document.createElement('li');
                    parentTitle.className = 'parent-title';

                    if (link) {
                        parentTitle.appendChild(link.cloneNode(true));
                    }

                    const backClick = document.createElement('li');
                    backClick.className = 'back-click';
                    backClick.textContent = 'Main Menu';

                    ul.prepend(parentTitle);
                    ul.prepend(backClick);
                }
            }
        });

        // Handle menu triggers
        const carets = document.querySelectorAll('.mbnav .has-sub>.mbnav__caret');
        carets.forEach(caret => {
            const link = caret.previousElementSibling;

            if (link && link.tagName === 'A') {
                link.classList.add('trigger-caret');
            }

            if (clickable) {
                caret.classList.add('trigger-caret');
            }
        });

        // Wrap elements
        const inner = document.querySelector('.mbnav__inner');
        if (inner) {
            const wrapper = document.createElement('div');
            wrapper.className = 'menu-wrap';
            const innerWrap = document.createElement('div');
            innerWrap.className = 'menu-inner';

            while (inner.firstChild) {
                innerWrap.appendChild(inner.firstChild);
            }

            wrapper.appendChild(innerWrap);
            inner.appendChild(wrapper);

            document.querySelectorAll('.mbnav__inner ul.menu > li.has-sub > ul').forEach(ul => {
                const wrap = document.createElement('div');
                wrap.className = 'menu-wrap';
                const innerDiv = document.createElement('div');
                innerDiv.className = 'menu-inner';

                ul.parentNode.insertBefore(wrap, ul);
                wrap.appendChild(innerDiv);
                innerDiv.appendChild(ul);
            });
        }

        // Open sub-menu
        document.querySelectorAll('.mbnav .has-sub>.trigger-caret').forEach(trigger => {
            trigger.addEventListener('click', e => {
                const li = trigger.closest('li');
                const link = li.querySelector(':scope > a');

                if (li.dataset.redirectOnNextClick === 'true') {
                    const href = getLinkHref(link);

                    if (href) {
                        window.location.href = href;
                    }

                    return;
                }

                e.preventDefault();
                const siblings = li.parentElement.children;
                Array.from(siblings).forEach(sib => {
                    if (sib !== li) {
                        sib.classList.remove('is-open', 'open');
                    }
                });
                li.classList.add('is-open', 'open');
                body.classList.add('scroll-fixed');
                updateMenuSlide(100);
            });
        });

        // Backward slide
        document.querySelectorAll('.mbnav__inner .back-click').forEach(backBtn => {
            backBtn.addEventListener('click', () => {
                const li = backBtn.closest('li.has-sub');
                if (li) {
                    li.classList.remove('is-open', 'open');
                    li.dataset.redirectOnNextClick = 'true';
                }

                updateMenuSlide(-100);
            });
        });
    });

    let headerTopHeight = 0;

    function updateHeaderPadding() {
        const menuInner = document.querySelector('.mbnav .menu-wrap');
        if (!menuInner) {return;}

        const header = document.querySelector('header.main-header');
        if (!header) {return;}

        const headerTop = header.querySelector('.header-top');
        const headerBottom = header.querySelector('.header-bottom');

        // Store height only once (before it's hidden)
        if (headerTop && headerTopHeight === 0) {
            headerTopHeight = headerTop.offsetHeight;
        }

        let paddingValue = header.offsetHeight;

        if (headerTop && headerBottom) {
            const isSticky =
                header.classList.contains('stuck') ||
                window.scrollY > headerTopHeight;

            if (isSticky) {
                paddingValue = headerBottom.offsetHeight;
            }
        }

        header.style.setProperty('--hasPadding', paddingValue + 'px');
    }

    // Events
    window.addEventListener('load', updateHeaderPadding);
    window.addEventListener('resize', updateHeaderPadding);
    window.addEventListener('scroll', updateHeaderPadding);
};

export default DeviceMenu;